var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('b-link',{staticClass:"px-2",attrs:{"href":_vm.mapUrl,"target":_vm.target}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }